import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import {
  generateUniqueNumber,
  updateObjectInArray,
} from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import ProductTasteForm from "../../../components/forms/setup/productTastes/ProductTasteForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";

export function ProductTastesViewModel(addSnackbar, logout) {
  const [loading, setLoading] = useState(false);
  const [productTastes, setProductTastes] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getProductTastes = async function (search, page) {
    setLoading(true);

    let callResult = await makeGetApiCall(
      `productTastes?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setProductTastes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createTaste = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("productTastes/create", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getProductTastes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateTaste = async function (values, index) {
    let callResult = await makePutApiCall(`productTastes/${values.id}`, values);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...productTastes.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setProductTastes({ ...productTastes, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddNewSlideOver = (isEdit, taste, index) => {
    setSlideOver({
      childComponent: (
        <ProductTasteForm
          taste={taste}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateTaste(payload, index) : createTaste(payload)
          }
          title={isEdit ? `Update ${taste.name}` : "Add new taste"}
          inProgress={false}
        />
      ),
      open: true,
    });
  };

  const deleteTaste = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteProductTaste/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = productTastes.data.filter((item) => item.id !== id);
      setProductTastes({ ...productTastes, data: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDelete = function (taste, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteTaste(taste.id, index)}
          message={`Are you sure you want to delete ${taste.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddNewSlideOver,
    getProductTastes,
    loading,
    productTastes,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDelete,
  };
}
